module.exports = __webpack_public_path__ + "img/canvas-night-normal.54dc11ca.jpg";